/**
 * @module api-web:cggzt
 * @description
 */
import service from '@/service'

// 列表查询接口
export function getList(data) {
  return service['api-scm']({
    url: '/scm/workspace/purchase/getList',
    method: 'post',
    data
  })
}
// 采购代办列表
export function getTodoList(data) {
  return service['api-scm']({
    url: '/scm/workspace/todo/getTodoList',
    method: 'post',
    data
  })
}

// 转采购
export function goPurchase(data) {
  return service['api-scm']({
    url: '/scm/workspace/purchase/transfer',
    method: 'post',
    data,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

// 采购待办转采购
export function goTodoPurchase(data) {
  return service['api-scm']({
    url: '/scm/workspace/todo/transfer',
    method: 'post',
    data,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}
/**
 * 供应商
 * @param {{supplierName:string}} params
 */
export function getSupplierInformationPullList(params) {
  return service['api-web']({
    url: '/public/data/getSupplierInformationPullList',
    method: 'get',
    params
  })
}

// 提交
export function goSubmit(data) {
  return service['api-scm']({
    url: '/scm/workspace/purchase/submit',
    method: 'post',
    data
  })
}

// 采购待办提交
export function goTodoSubmit(data) {
  return service['api-scm']({
    url: '/scm/workspace/todo/submit',
    method: 'post',
    data
  })
}

// 采购工作台导出
export function exportWorkSpace(data) {
  return service['api-scm']({
    url: '/scm/workspace/purchase/exportWorkSpace',
    method: 'post',
    data
  })
}
// 采购代办导出
export function exportTodoList(data) {
  return service['api-scm']({
    url: '/scm/workspace/todo/exportTodoList',
    method: 'post',
    data
  })
}
// 指派
export function appoint(data) {
  return service['api-scm']({
    url: '/scm/workspace/purchase/appoint',
    method: 'post',
    data
  })
}
// 根据商品编码获取商品信息
export function getProductInfoByCodeList(data) {
  return service['api-web']({
    url: '/public/product/getProductInfoByCodeList',
    method: 'post',
    data
  })
}

// 获取任务统计
export function appointTaskStatistics(data) {
  return service['api-scm']({
    url: '/scm/workspace/purchase/appointTaskStatistics',
    method: 'post',
    data
  })
}

// 召回
export function callBack(data) {
  return service['api-scm']({
    url: '/scm/workspace/purchase/callBack',
    method: 'post',
    data
  })
}
